import { defineStore } from 'pinia'
import { ref, computed, Ref } from 'vue'
import { getFacility, updateFacility } from '@services/facility.service'
import { type Facility } from '@m/cabinet/modules/Facility/types'

const id = 'facilityStore'

export const useFacilityStore = defineStore(id, () => {
  const loading: Ref<boolean> = ref(false)
  const facility: Ref<Partial<Facility>> = ref({})
  

  const languagesDefault = computed(() => facility.value?.languagesDefault || null)
  const languagesAvailable = computed(() => facility.value?.languagesAvailable || [])

  function setLoading(value: boolean): void {
    loading.value = value
  }

  function setFacility(newFacility: Facility): void {
    facility.value = newFacility
  }

  async function receive(id: string): Promise<void> {
    setLoading(true)

    return await getFacility.execute({ id })
      .then(({ item }) => {
        setFacility(item)
      })
      .catch((error: Response) => {
        setFacility(null)
        console.warn(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  function patch(id, payload: Record<string, any>) {
    return updateFacility.execute({ id }, payload)
      .then(({ item }) => {
        setFacility(item)
        return item
      })
  }

  return {
    loading,
    facility,
    languagesDefault,
    languagesAvailable,
    setFacility,
    setLoading,
    receive,
    patch,
  }
})
